<template>
    <v-container fluid class="pa-6">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Habilitacoes/Divergencias</span>
                        <v-breadcrumbs class="app-breadcrumb" divider=">" :items="[
                            {
                                text: 'Homepage',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Habilitacoes/Divergencias',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn color="primary" elevation="0" to="/divergencias/incluir">
                            <v-icon left small>mdi-plus</v-icon>
                            Incluir Hab/Div
                        </v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card flat class="filter-card">
                    <v-card-text class="pa-5">
                        <v-form @submit.prevent="load()">
                            <v-row>
                                <v-col>
                                    <v-text-field dense id="name" label="Nome" v-model="dataList.filter.name" hide-details
                                        outlined></v-text-field>
                                </v-col>
                                <v-col v-if="dataList.resultsVisible">
                                    <v-select dense :items="dataset.eventStatus" label="Status"
                                        v-model="dataList.filter.status" item-value="id" item-text="name" outlined
                                        hide-details="auto">
                                    </v-select>
                                </v-col>
                                <v-col>
                                    <v-select dense :items="dataset.eventTypes" label="Tipo" v-model="dataList.filter.type"
                                        item-value="id" item-text="name" outlined hide-details="auto">
                                    </v-select>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark elevation="0"><v-icon left small>mdi-magnify</v-icon>Filtrar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="table-card">
                    <v-card-title class="table-card-title">Hab/Div</v-card-title>
                    <v-card-text>
                        <!-- Resultado das analises so e exibido depois da entrega do RVC pela Administracao Judicial -->
                        <v-alert v-if="!dataList.resultsVisible" dense text type="info" class="mb-4">
                            O resultado da análise dos pedidos (aprovado, rejeitado ou parcial) será exibido após a entrega do
                            Relatório de Verificação de Créditos (RVC) pela Administração Judicial. Até lá, os pedidos constam como "Em análise".
                        </v-alert>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            :server-items-length="dataList.count" @update:items-per-page="pageSizeChanged"
                            @update:page="pageChanged" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum usuário foi encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">
                            <template v-slot:[`item.user.name`]="{ item }">
                                <span class="list-item-title text-capitalize">{{ item.user.name }}</span><br />
                            </template>

                            <template v-slot:[`item.status`]="{ item }">
                                <v-chip v-if="item.result_visible === false" color="blue-grey" label text-color="white">
                                    Em análise
                                </v-chip>
                                <v-chip v-else :color="getColorByStatus(item.status)" label text-color="white">
                                    {{ item.status | enum(dataset.eventStatus, "id", "name") }}
                                </v-chip>
                            </template>

                            <template v-slot:[`item.type`]="{ item }">
                                {{ item.type == 2 ? 'Divergência' : 'Habilitação' }}
                            </template>

                            <template v-slot:[`item.enable_contradictory`]="{ item }">
                                    <span v-if="item.enable_contradictory == 2">
                                        {{ item.contradictory_deadline_at | defaultDate('DD/MM/YYYY', false, true) }}
                                    </span>
                                    <span v-else>Fechado</span>
                            </template>


                            <template v-slot:[`item.created_at`]="{ item }">
                                {{ item.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                            </template>

                            <template v-slot:[`item.analyzed_at`]="{ item }">
                                <span v-if="item.analyzed_at && item.analyzed_at !== '0000-00-00 00:00:00'"> {{
                                    item.contract |
                                    defaultDate("DD/MM/YYYY HH:mm:ss") }}</span>
                                <span v-else>N/A</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-icon :disabled="!$check('users/1', ['PATCH'])" @click="viewItem(item)" size="large"
                                    class="me-2">
                                    mdi-pencil-outline
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"
import eventStatus from "@/common/data/event-status.data";

Vue.use(VueLodash)

export default {
    name: "UserList",

    data: () => ({
        dataset: {
            eventStatus: [{ id: "", name: "Todos" }, ...eventStatus],
            eventTypes: [{ id: "", name: "Todos" }, { id: 1, name: "Habilitação" }, { id: 2, name: "Divergência" }],
            data: {}
        },
        dataList: {
            filter: {
                name: "",
                status: "",
                type: ""
            },
            headers: [
                { text: "Credor", value: "user.name" },
                { text: "Tipo", value: "type" },
                { text: "Solicitado em", value: "created_at" },
                { text: "Prazo contraditório", value: "enable_contradictory" },
                { text: "Status", value: "status" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            // false = RVC nao entregue: status oculto (vem da API)
            resultsVisible: true,
            loading: false,
            count: 0,
            options: {
                page: 1,
                itemsPerPage: 50,
                sortBy: ['name'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
            }
        },
    }),

    created() {
        this.load();
    },

    methods: {
        clientPageText() {
            return `${this.dataList.options.page}`;
        },

        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.itemsPerPage = size;
            this.dataList.options.page = 1;
            this.load();
        },

        getColorByStatus(status) {
            switch (status) {
                case 0:
                    return 'warning'
                case 1:
                    return 'accent'
                case 2:
                    return 'error'
                default:
                    break;
            }
        },

        debounce: _.debounce(function () {
            this.reload();
        }, 500),

        reload: function () {
            this.load();
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            this.dataList.loading = true;

            var limit = this.dataList.options.itemsPerPage;
            try {
                const result = await axios.get('/api/admin/user-events/client/list', {
                    params: {
                        page: this.dataList.options.page,
                        limit: limit,
                        search: search,
                    },
                });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.paging.total;
                // false enquanto o RVC nao foi entregue (status mascarado pela API)
                this.dataList.resultsVisible = result.data.content.results_visible !== false;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`divergencias/${item.id}`);
        },
    },
};
</script>
